import Users from '@/apiClient/Users'
import Signatures from '@/apiClient/Signatures'
import _, { isEmpty, reduce, filter, each } from 'lodash'
import {
  SET_SIGNED_DOCS,
  SET_SIGNED_LAST_DOC_ID,
  SET_UNSIGNED_DOCS,
  SET_UNSIGNED_LAST_DOC_ID,
  SET_UNSIGNED_TOTAL_DOCS,
  SET_EFIMERO_FOLDERS,
  SET_ENABLE_DOCS,
  SET_DOCUMENT_SELECTED,
  SET_IMAGEVALUE,
  UPDATE_DOCUMENT_SELECTED,
  UPDATE_EFORM_SIGNED,
  SET_LOADING_IMAGE,
  SET_DOCUMENT_FILE,
  SET_NUMBER_PAGE,
  SET_TOTAL_PAGES,
  SET_REQUESTED_LIST,
  SET_DOCUMENTS_UNSIGNED_PARAMS_FILTER,
  SET_DOCUMENTS_SIGNED_PARAMS_FILTER,
  SET_FOLDERS_AVAILABLES,
  CLEAR_ALL_DOCUMENTS_STATE
} from './mutations-types'

const User = new Users()
const Signature = new Signatures()

const filterToApply = filters => {
  if (!isEmpty(filters)) {
    const params = {
      folder_id:
        filters.foldersSelected && filters.foldersSelected.length
          ? JSON.stringify(filters.foldersSelected)
          : [],
      from: filters.dateFilters && filters.dateFilters.start,
      to: filters.dateFilters && filters.dateFilters.end
    }
    for (const [key, value] of Object.entries(params)) {
      if (isEmpty(value)) {
        delete params[key]
      }
    }
    return params
  }
  return {}
}

const actions = {
  clearSigned: ({ commit }) => {
    commit(SET_SIGNED_DOCS, [])
    commit(SET_SIGNED_LAST_DOC_ID, null)
  },
  clearUnSigned: ({ commit }) => {
    commit(SET_UNSIGNED_DOCS, [])
    commit(SET_UNSIGNED_LAST_DOC_ID, null)
  },
  setFolderAvailable: async ({ commit, state }) => {
    if (!isEmpty(state.folders)) return
    const {
      data: { data = [] }
    } = await User.getFoldersPublished()
    const visibleFolders = data.filter(folder => folder.visible === 't')
    const mappedFolders = visibleFolders.map(folder => {
      return {
        carpeta_id: parseInt(folder.id, 10),
        carpeta_nombre: folder.carpeta_nombre
      }
    })
    commit(SET_FOLDERS_AVAILABLES, mappedFolders)
  },
  setUnsignedFilters: ({ commit, dispatch }, { filters }) => {
    commit(SET_DOCUMENTS_UNSIGNED_PARAMS_FILTER, { ...filters })
  },
  setSignedFilters: ({ commit, dispatch }, { filters }) => {
    commit(SET_DOCUMENTS_SIGNED_PARAMS_FILTER, { ...filters })
  },
  setDocumentsSigned: async ({ commit, state }, { append }) => {
    try {
      const appliedFilters = {
        ...filterToApply(state.signedFilters),
        ...(append && state.signedLastId ? { lastkey: state.signedLastId } : {})
      }
      const response = await User.getUserDocumentsSigned(appliedFilters)
      if (response.status === 200) {
        const {
          data: { data }
        } = response
        const signed = data.rows || []
        if (append) {
          commit(SET_SIGNED_DOCS, [...state.signed, ...signed])
        } else {
          commit(SET_SIGNED_DOCS, signed)
        }
        commit(SET_SIGNED_LAST_DOC_ID, data.lastkey)
      }
    } catch (e) {
      console.error(e)
    }
  },
  setDocumentsUnSigned: async ({ commit, state, dispatch }, { append }) => {
    try {
      const appliedFilters = {
        ...filterToApply(state.unsignedFilters),
        ...(append && state.unSignedLastId
          ? { lastkey: state.unSignedLastId }
          : {})
      }
      const response = await User.getUserDocumentsUnSigned(appliedFilters)
      if (response.status === 200) {
        const {
          data: { data }
        } = response
        const unsigned = data.rows || []
        if (append) {
          commit(SET_UNSIGNED_DOCS, [...state.unsigned, ...unsigned])
        } else {
          commit(SET_UNSIGNED_DOCS, unsigned)
        }
        commit(SET_UNSIGNED_LAST_DOC_ID, data.lastkey)
        commit(SET_UNSIGNED_TOTAL_DOCS, state.unsigned.length)
      }
    } catch (e) {
      console.error(e)
    }
  },
  setInitialDocumentsInbox: async ({ commit, dispatch, state }) => {
    try {
      await Promise.all([
        dispatch('setDocumentsUnSigned', { append: false }),
        dispatch('setDocumentsSigned', { append: false })
      ])
      commit(SET_REQUESTED_LIST, true)
      commit(SET_UNSIGNED_TOTAL_DOCS, state.unsigned.length)
      commit(SET_ENABLE_DOCS, [])
    } catch (e) {
      commit(SET_REQUESTED_LIST, true)
      commit(SET_UNSIGNED_TOTAL_DOCS, 0)
      commit(SET_ENABLE_DOCS, [])
    }
  },
  setInitialDocuments: async ({ commit }) => {
    const res = await User.getFolders()
    if (res.status === 200) {
      const {
        data: {
          results: { data }
        }
      } = res

      const visibleFolders = filter(data, folder => folder.visible === 't')

      const efimeroFolders = reduce(
        visibleFolders,
        (results, folder) => {
          if (folder.efimero === 't') {
            results.push(folder.carpeta_id)
          }
          return results
        },
        []
      )

      commit(SET_EFIMERO_FOLDERS, efimeroFolders)

      const enableDocsPromises = []

      each(visibleFolders, folder => {
        if (folder.carpeta_id) {
          const getDocsPromise = User.getDocuments(folder.carpeta_id)
          enableDocsPromises.push(getDocsPromise)
        }
      })

      const getDocsResponses = await Promise.all(enableDocsPromises)

      const enabledDocs = _.chain(getDocsResponses)
        .filter(response => !isEmpty(response.data.results.data))
        .map(response => response.data.results.data)
        .flatten()
        .value()

      commit(SET_ENABLE_DOCS, enabledDocs)
      commit(SET_REQUESTED_LIST, true)

      const unsignedDocs = filter(enabledDocs, document => {
        if (document.firmado === 'NO FIRMADO') {
          return document
        }
      })
      commit(SET_UNSIGNED_TOTAL_DOCS, unsignedDocs.length)
      commit(SET_SIGNED_DOCS, [])
      commit(SET_UNSIGNED_DOCS, [])
    }
  },
  setDocumentSelected: ({ commit }, payload) => {
    commit(SET_DOCUMENT_SELECTED, payload)
  },
  setImageValue: ({ commit }, payload) => {
    commit(SET_IMAGEVALUE, payload)
  },
  updateDocumentSelected: async (
    { state, commit, rootState, dispatch },
    { status, body, reason, inbox }
  ) => {
    const {
      user: {
        aplicacion: { id: idApp }
      }
    } = rootState
    const {
      document: { id: idDoc }
    } = state

    if (status === 'FIRMADO CONFORME') {
      await Signature.documentSignature(idApp, idDoc, body)
    } else {
      await Signature.dissatisfiedDocumentSignature(idApp, idDoc, body, reason)
    }

    if (inbox) {
      dispatch('setInitialDocumentsInbox')
    } else {
      dispatch('setInitialDocuments')
    }
    commit(UPDATE_DOCUMENT_SELECTED, status)
  },
  updateEformSigned: ({ commit, dispatch }, { inbox }) => {
    if (inbox) {
      dispatch('setInitialDocumentsInbox')
    } else {
      dispatch('setInitialDocuments')
    }
    commit(UPDATE_EFORM_SIGNED)
  },
  setLoadingImage: ({ commit }, payload) => {
    commit(SET_LOADING_IMAGE, payload)
  },
  setDocumentFile: async ({ commit }, { idApp, idDoc }) => {
    const response = await User.showPdfDownload(idApp, idDoc)
    const documentFile = `data:application/pdf;base64,${response}`
    commit(SET_DOCUMENT_FILE, documentFile)
  },
  setCurrentPage: ({ commit }, payload) => {
    commit(SET_NUMBER_PAGE, payload)
  },
  setTotalPages: ({ commit }, payload) => {
    commit(SET_TOTAL_PAGES, payload)
  },
  clearAllDocumentsState: ({ commit }) => {
    commit(CLEAR_ALL_DOCUMENTS_STATE)
  }
}

export default actions
